import { render, staticRenderFns } from "./PricingItem.vue?vue&type=template&id=b6e74500&scoped=true&"
import script from "./PricingItem.vue?vue&type=script&lang=js&"
export * from "./PricingItem.vue?vue&type=script&lang=js&"
import style0 from "./PricingItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PricingItem.vue?vue&type=style&index=1&id=b6e74500&lang=scss&scoped=true&"
import style2 from "./PricingItem.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e74500",
  null
  
)

export default component.exports